import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "py-20 frm-footer__bg-top relative z-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "frm-footer__bg-img absolute top-0 left-0 z-[-1] h-full w-full bg-no-repeat bg-cover bg-center",
  style: {"background-image":"url('/assets/footer-bg.png')"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-20" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/shinagawa-logo.svg",
      alt: "logo",
      class: "h-[55px] mx-auto invert brightness-0 contrast-100 saturate-100"
    })
  ])
], -1)
const _hoisted_5 = { class: "flex flex-wrap justify-center px-[5%] mb-20 space-y-10 lg:space-y-0" }
const _hoisted_6 = { class: "text-center w-full lg:w-[20%]" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "text-primary-200 font-medium" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:block w-[1px] h-20 bg-primary-200 mx-10 self-center" }, null, -1)
const _hoisted_10 = { class: "text-center w-full lg:w-[20%]" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  rel: "noreferrer",
  href: "mailto:info@shinagawa-healthcare.ph",
  class: "text-white text-sm font-medium block"
}, " info@shinagawa-healthcare.ph ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  rel: "noreferrer",
  href: "mailto:japanesedesk@shinagawa-healthcare.ph",
  class: "text-white text-sm font-medium block mb-4"
}, " japanesedesk@shinagawa-healthcare.ph ", -1)
const _hoisted_14 = { class: "text-primary-200 font-medium" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:block w-[1px] h-20 bg-primary-200 mx-10 self-center" }, null, -1)
const _hoisted_16 = { class: "text-center w-full lg:w-[20%]" }
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  rel: "noreferrer",
  href: "tel:(+63) 917-846-6762",
  class: "text-white text-sm font-medium block"
}, " (+63) 917-846-6762 – GLOBE ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  rel: "noreferrer",
  href: "tel:(+63) 962-067-3669",
  class: "text-white text-sm font-medium block mb-4"
}, " (+63) 962-067-3669 – SMART ", -1)
const _hoisted_20 = { class: "text-primary-200 font-medium" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:block w-[1px] h-20 bg-primary-200 mx-10 self-center" }, null, -1)
const _hoisted_22 = { class: "text-center w-full lg:w-[20%]" }
const _hoisted_23 = {
  href: "#",
  class: "text-white text-sm font-medium block mb-4"
}
const _hoisted_24 = { class: "text-primary-200 font-medium" }
const _hoisted_25 = {
  key: 0,
  class: "flex flex-col items-center space-y-4 mb-20"
}
const _hoisted_26 = { class: "text-white" }
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "px-[5%] text-center" }
const _hoisted_29 = { class: "flex items-center justify-center space-x-2 mb-4" }
const _hoisted_30 = ["href"]
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-200 font-medium" }, "Copyright 2023 Shinagawa Diagnostics and Preventive Care. All Rights Reserved.", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "bg-primary-700 flex items-center justify-center flex-wrap px-[5%] pt-4 space-x-14" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://shinagawa.ph/data-privacy-notice/",
    target: "_blank",
    class: "text-white font-medium whitespace-nowrap mb-4"
  }, "Terms and Conditions"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://shinagawa.ph/data-privacy-notice/",
    target: "_blank",
    class: "text-white font-medium whitespace-nowrap mb-4"
  }, "Privacy Policy")
], -1)

import Pages from "@/classes/Pages";
import { MapPinIcon, EnvelopeIcon, PhoneIcon, ClockIcon } from "@heroicons/vue/24/solid";
import { onMounted, ref } from "vue";
import ButtonComponent from "@/components/ButtonComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BottomNavigation',
  setup(__props) {

const feedback = ref()

const fetchFeedback = () => {
    // TODO: adjust data structure base on BE
    Pages.fetchSlug('header_footer')
        .then((result: any) => {
            feedback.value = result.data?.page.content;
        })
        .catch((err) => {
            console.log(err)
        })
}

const socialaccts = [
    {
        icon: '/assets/icon/ic-facebook.svg',
        link: 'https://www.facebook.com/shinagawadiagnostic',
    },
    {
        icon: '/assets/icon/ic-instagram.svg',
        link: 'https://www.instagram.com/shinagawadiagnostic/',
    },
    {
        icon: '/assets/icon/ic-youtube.svg',
        link: 'https://www.youtube.com/@ShinagawaPhilippines',
    },
    {
        icon: '/assets/icon/ic-linkedin.svg',
        link: 'https://www.linkedin.com/in/shinagawa-philippines/',
    }
]

onMounted(() => {
    fetchFeedback();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(MapPinIcon), { class: "w-10 mx-auto text-primary-200 mb-4" }),
          _createElementVNode("a", {
            target: "_blank",
            rel: "noreferrer",
            href: feedback.value?.footer_address_link || 'https://goo.gl/maps/5Wjpd6hTxudHPACt8',
            class: "text-white text-sm font-medium block mb-4"
          }, _toDisplayString(feedback.value?.footer_address || '8F & 23F Ore Central Tower, Bonifacio Global City, Taguig'), 9, _hoisted_7),
          _createElementVNode("p", _hoisted_8, _toDisplayString(feedback.value?.footer_address_label || 'Address'), 1)
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(EnvelopeIcon), { class: "w-10 mx-auto text-primary-200 mb-4" }),
          (feedback.value?.footer_email_list && feedback.value.footer_email_list.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(feedback.value.footer_email_list, (item, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: index,
                  target: "_blank",
                  rel: "noreferrer",
                  href: `mailto:${item.email}`,
                  class: _normalizeClass(["text-white text-sm font-medium block", { 'mb-4': index === feedback.value.footer_email_list.length - 1 }])
                }, _toDisplayString(item.email), 11, _hoisted_11))
              }), 128))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_12,
                _hoisted_13
              ], 64)),
          _createElementVNode("p", _hoisted_14, _toDisplayString(feedback.value?.footer_email_label || 'Mailbox'), 1)
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_unref(PhoneIcon), { class: "w-10 mx-auto text-primary-200 mb-4" }),
          (feedback.value?.footer_phone_list && feedback.value.footer_phone_list.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(feedback.value.footer_phone_list, (item, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: index,
                  target: "_blank",
                  rel: "noreferrer",
                  href: `tel:${item.number}`,
                  class: _normalizeClass(["text-white text-sm font-medium block", { 'mb-4': index === feedback.value.footer_phone_list.length - 1 }])
                }, _toDisplayString(item.display), 11, _hoisted_17))
              }), 128))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_18,
                _hoisted_19
              ], 64)),
          _createElementVNode("p", _hoisted_20, _toDisplayString(feedback.value?.footer_phone_label || 'Trunkline'), 1)
        ]),
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_unref(ClockIcon), { class: "w-10 mx-auto text-primary-200 mb-4" }),
          _createElementVNode("a", _hoisted_23, _toDisplayString(feedback.value?.footer_hours || 'Monday to Saturday 8AM to 5PM'), 1),
          _createElementVNode("p", _hoisted_24, _toDisplayString(feedback.value?.footer_hours_label || 'Operating Hours'), 1)
        ])
      ]),
      (feedback.value?.footer_feedback_link)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("p", _hoisted_26, _toDisplayString(feedback.value?.footer_feedback_title ?? 'Have suggestions or feedback? Let us know!'), 1),
            _createElementVNode("a", {
              target: "_blank",
              rel: "noopener noreferrer",
              href: feedback.value?.footer_feedback_link
            }, [
              _createVNode(ButtonComponent, {
                secondary: "",
                shadow: "",
                text: "Feedback Form",
                "show-icon": false
              })
            ], 8, _hoisted_27)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socialaccts, (i) => {
            return _createElementVNode("a", {
              key: i,
              href: i.link,
              target: "_blank",
              class: "w-8 h-8 bg-white rounded-full flex items-center justify-center",
              ref_for: true,
              ref: "noreferrer"
            }, [
              _createElementVNode("img", {
                src: i.icon,
                alt: ""
              }, null, 8, _hoisted_31)
            ], 8, _hoisted_30)
          }), 64))
        ]),
        _hoisted_32
      ])
    ]),
    _hoisted_33
  ]))
}
}

})